import { lazy } from 'react';

const BillingLanding = lazy(() => import('containers/BillingLanding'));
const Forbidden = lazy(() => import('components/Forbidden'));

const ROUTES = {
  LANDING: {
    path: '/landing',
    name: 'Billing & Licensing',
    getComponent: BillingLanding,
  },
  FORBIDDEN: {
    path: '/forbidden',
    name: 'Forbidden',
    getComponent: Forbidden,
  },
};

export default ROUTES;
